import request from './request';

const panorama_edges = {
	async getPanoramaEdges(query) {
		const response = await request.get('/app/panorama-edges', query);
		return response;
	}
};

export default panorama_edges;
